import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import { UserIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { getPersonInitials } from 'utils/loanApplication';

import { selectBorrowerCrmContactById } from 'store/loanApplications/selectors';

import { getContactAvatarColor, getContactDisplayName } from '../crmContact.utils';

import { EMPTY_ICON_SIZE } from './BorrowerCrmAvatar.constants';
import {
  emptyAvatarStyles,
  getLinkedAvatarStyles,
  initialsStyles,
} from './BorrowerCrmAvatar.styles';

// Read-only CRM contact indicator shown next to a borrower's name in the grid.
// Linked: an initials avatar in the contact's deterministic color. Unlinked: a
// quiet person-glyph placeholder. Assigning/unlinking happens in the edit sidebar.
const BorrowerCrmAvatar = ({ borrowerId }) => {
  const contact = useSelector(state => selectBorrowerCrmContactById(state, borrowerId));

  if (!contact) {
    return (
      <Box aria-label="No CRM contact" sx={emptyAvatarStyles} title="No CRM contact">
        <UserIcon size={EMPTY_ICON_SIZE} />
      </Box>
    );
  }

  const name = getContactDisplayName(contact);

  return (
    <Box
      aria-label={`CRM contact: ${name}`}
      sx={getLinkedAvatarStyles(getContactAvatarColor(contact))}
      title={`CRM contact: ${name}`}
    >
      <Typography sx={initialsStyles} variant="medium12">
        {getPersonInitials(contact)}
      </Typography>
    </Box>
  );
};

BorrowerCrmAvatar.propTypes = {
  borrowerId: PropTypes.string.isRequired,
};

export default memo(BorrowerCrmAvatar);
